import { strapiFetch } from 'lib/strapi'
import {
  submitContactFailure,
  submitContactRequest,
  submitContactSuccess,
} from './contactSlice'

type ContactPayload = {
  name: string
  companyName: string
  email: string
  monthlyFxVolume: string
  message: string
}

export const submitContactFormAction = (payload: ContactPayload) => {
  return async (dispatch: any) => {
    try {
      dispatch(submitContactRequest())

      const { data }: any = await strapiFetch('/api/contacts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: payload,
        }),
      })

      dispatch(
        submitContactSuccess({
          item: data,
        })
      )

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ event: 'contact_form_success' })
    } catch (err: any) {
      console.log(err)
      dispatch(
        submitContactFailure({
          errorMessage: err?.message || 'Unable to submit contact request.',
        })
      )
    }
  }
}
